import { render, staticRenderFns } from "./EventPriceBreakdown.vue?vue&type=template&id=73273f6f&"
import script from "./EventPriceBreakdown.vue?vue&type=script&lang=js&"
export * from "./EventPriceBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports